/**
 * RouteModule is the base class for all route modules. This class should be
 * extended by all route modules.
 */ export class RouteModule {
    constructor({ userland, definition }){
        this.userland = userland;
        this.definition = definition;
    }
}

//# sourceMappingURL=route-module.js.map